import React from "react";
import {
  Card,
  CardContent,
  Chip,
  CircularProgress,
  IconButton,
  Paper,
  Stack,
  Tooltip,
  Typography,
  Box,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import StarIcon from "@mui/icons-material/Star";

const LocationListCard = ({
  loading,
  locations,
  selectedLocationId,
  onSelect,
  onEdit,
  onDelete,
  onSetPrimary,
}) => {
  return (
    <Card sx={{ borderRadius: 3 }}>
      <CardContent>
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h6" fontWeight={700}>
            Locations List
          </Typography>
          {loading && <CircularProgress size={22} />}
        </Stack>

        <Stack spacing={2}>
          {!locations.length && !loading && (
            <Paper variant="outlined" sx={{ p: 3, borderRadius: 2, textAlign: "center" }}>
              <Typography variant="body2" color="text.secondary">
                No locations found.
              </Typography>
            </Paper>
          )}

          {locations.map((location) => {
            const isSelected = selectedLocationId === location.id;

            return (
              <Paper
                key={location.id}
                variant="outlined"
                onClick={() => onSelect(location.id)}
                sx={{
                  p: 2,
                  borderRadius: 2,
                  cursor: "pointer",
                  borderColor: isSelected ? "primary.main" : "divider",
                  backgroundColor: isSelected ? "action.hover" : "inherit",
                }}
              >
                <Stack direction={{ xs: "column", sm: "row" }} justifyContent="space-between" spacing={2}>
                  <Box>
                    <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
                      <Typography variant="subtitle1" fontWeight={700}>
                        {location.name}
                      </Typography>

                      {location.is_primary && (
                        <Chip size="small" color="warning" icon={<StarIcon />} label="Primary" />
                      )}

                      <Chip
                        size="small"
                        color={location.is_active ? "success" : "default"}
                        label={location.is_active ? "Active" : "Inactive"}
                      />
                    </Stack>

                    <Typography variant="body2" color="text.secondary" mt={1}>
                      {[
                        location.address_line1,
                        location.street,
                        location.city,
                        location.state,
                        location.country,
                        location.postal_code,
                      ]
                        .filter(Boolean)
                        .join(", ")}
                    </Typography>

                    {location.contact_number && (
                      <Typography variant="body2" mt={0.5}>
                        Contact: {location.contact_number}
                      </Typography>
                    )}
                  </Box>

                  <Stack direction="row" spacing={1}>
                    {!location.is_primary && (
                      <Tooltip title="Set Primary">
                        <IconButton
                          color="warning"
                          onClick={(e) => {
                            e.stopPropagation();
                            onSetPrimary(location.id);
                          }}
                        >
                          <StarIcon />
                        </IconButton>
                      </Tooltip>
                    )}

                    <Tooltip title="Edit">
                      <IconButton
                        color="primary"
                        onClick={(e) => {
                          e.stopPropagation();
                          onEdit(location);
                        }}
                      >
                        <EditIcon />
                      </IconButton>
                    </Tooltip>

                    <Tooltip title="Delete">
                      <IconButton
                        color="error"
                        onClick={(e) => {
                          e.stopPropagation();
                          onDelete(location.id);
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Tooltip>
                  </Stack>
                </Stack>
              </Paper>
            );
          })}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default LocationListCard;